import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from 'js-cookie';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
const defaultHeaders = { "Content-Type": "application/json" };

const logoutViaApi: any = createAsyncThunk("user/endSession",
  async ({ userToken }: any, { rejectWithValue }) => {
    try {
      const headers = { ...defaultHeaders, Authorization: `Bearer ${userToken}` };
      const { data } = await axios.patch(`${baseUrl}logout`, {}, { headers });

      if (typeof window !== "undefined") {
        Cookies.remove("qwid-token");
        window.location.href = '/'
      }

      return data?.content?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export {
  logoutViaApi,
}